<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import utils from 'apps/utility/vue-common'
import dateInput from 'apps/bankrate-calculators/components/date-input.vue'
import amortizationMethods from 'apps/bankrate-calculators/common/amortization-functions'
import calculatorEventBus from 'apps/bankrate-calculators/events'

export default {
  template: utils.methods.isDesktop()
    ? require('./template.html')
    : require('./mobile-template.html'),
  mixins: [amortizationMethods],
  components: { dateInput },
  props: {
    calcType: {
      type: String
    },
    showStartDate: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      amortizationSchedule: []
    }
  },
  computed: {
    showAmortization() {
      return this.$store.state.showAmortizationSchedule
    },
    startDate() {
      return moment(this.$store.state.startDate, 'MM/DD/YYYY')
    },
    estimatedPayoffDate() {
      return this.$store.state.estimatedPayoffDate.format('MMMM D, YYYY')
    },
    ...mapState(['loanAmount', 'termInMonths', 'interestRate']),
    ...mapGetters(['mortgageAmount'])
  },
  methods: {
    toggleAmortizationSchedule(event, text) {
      this.$store.dispatch('toggleAmortizationSchedule', { event, text })
    }
  },
  watch: {
    startDate() {
      if (this.showStartDate) {
        this.buildAmortizationSchedule()
      }
    }
  },
  created() {
    this.buildAmortizationSchedule()
    calculatorEventBus.$on(
      'amortizationDataChanged',
      this.updateAmortizationSchedule
    )
  }
}
</script>
<style>
#calculator .extraPaymentsButton {
  padding: 3px 15px !important;
}
a.extraPaymentsButton.closed::after {
  border-width: 7px 7px 0 7px !important;
}
a.extraPaymentsButton.open::after {
  border-width: 0 7px 7px 7px !important;
}
</style>
